import FilteredResultsText from './FilteredResultsText';
export default FilteredResultsText;